import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

interface IUSB {
  hostId: string;
  name: string;
  mountedTo: string;
  status: string;
  id: string;
}
interface IMetaData {
  items: number;
  page: number;
  pages: number;
  pagesize: number;
}

interface IUSBDetails {
  usbData: IUSB[];
  metaData: IMetaData;
}

const initialState: IUSBDetails = {
  usbData: [],
  metaData: {
    items: 0,
    page: 1,
    pages: 1,
    pagesize: 10,
  }
};

const slice = createSlice({
  name: "usbDetails",
  initialState,
  reducers: {
    setUsbData(state, action) {
      state.usbData = action.payload;
    },
    setMetaData(state, action) {
      state.metaData = action.payload;
    },
    setUsbPage(state, action) {
      state.metaData.page = action.payload;
    },
    setUsbPageSize(state, action) {
      state.metaData.pagesize = action.payload;
    },
  },
});

export const getUsbDetails = (pageSize, page, enqueueSnackbar) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/service-agent/api/v1/usb-ip?meta=true&pageSize=${pageSize}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          // contextId: Id,
        },
      }
    );
    if (!response?.data?.status) {
      throw new Error(response?.data?.message);
    }else{
      dispatch(slice.actions.setUsbData(response?.data?.data));
      dispatch(slice.actions.setMetaData(response?.data?.metaData));
    }
  } catch (error) {
    enqueueSnackbar(error?.message, {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export const mountUnmountUsb =
  (serviceId, usb_id, enqueueSnackbar, type, callback?: (error?: any) => void) => async () => {
    try {
      const mountData = { serviceId: serviceId };
      const response = type === "Mount" ? await axios.post(
        `${process.env.REACT_APP_API_URL}/service-agent/api/v1/usb-ip/${usb_id}/initiate-mount`,
        mountData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ):
      await axios.post(
        `${process.env.REACT_APP_API_URL}/service-agent/api/v1/usb-ip/${usb_id}/unmount`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.status) {
        enqueueSnackbar(response?.data?.message, {
          variant: "success",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        callback();
      } else {
        enqueueSnackbar(response?.data?.message, {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

// export const UnmountUsb = (usb_id, enqueueSnackbar) => async () => {
//   try {
//     const response = await axios.post(
//       `${process.env.REACT_APP_API_URL}/api/v1/usb-ip/${usb_id}/unmount`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );
//     if (response?.data?.status) {
//       enqueueSnackbar(response?.data?.message, {
//         variant: "success",
//         preventDuplicate: true,
//         autoHideDuration: 5000,
//         anchorOrigin: {
//           vertical: "top",
//           horizontal: "right",
//         },
//       });
//     } else {
//       enqueueSnackbar(response?.data?.message, {
//         variant: "error",
//         preventDuplicate: true,
//         autoHideDuration: 5000,
//         anchorOrigin: {
//           vertical: "top",
//           horizontal: "right",
//         },
//       });
//     }
//   } catch (error) {
//     throw new Error(error);
//   }
// };

export const { 
  setUsbData,
  setUsbPage,
  setUsbPageSize
 } = slice.actions;

export const reducer = slice.reducer;
export default slice;
